import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Home from './pages/Home';
import SkillForm from './components/SkillForm';
import SkillList from './components/SkillList';
import PortfolioPreview from './components/PortfolioPreview';
import Login from './pages/Login';
import SignUp from './pages/SignUp'; // SignUpのインポート

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState(null);
  const [skills, setSkills] = useState([]);

  const handleLogin = (userId) => {
    setIsLoggedIn(true);
    setUserId(userId);
  };

  const handleSignUp = (userId) => {
    setIsLoggedIn(true);
    setUserId(userId);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserId(null);
    window.location.href = '/';
  };

  const handleSkillAdded = (newSkill) => {
    setSkills((prevSkills) => [...prevSkills, newSkill]);
  };

  const ProtectedRoute = ({ children }) => {
    return isLoggedIn ? children : <Navigate to="/login" />;
  };

  return (
    <Router>
      <div className="App">
        <header className="p-4 bg-blue-500 text-white">
          <h1 className="text-lg font-bold">オフィススキルポートフォリオ</h1>
          <nav className="mt-2">
            <Link to="/" className="mx-2 text-white hover:underline">ホーム</Link>
            {isLoggedIn ? (
              <>
                <Link to="/skills" className="mx-2 text-white hover:underline">スキル登録</Link>
                <Link to="/skills-list" className="mx-2 text-white hover:underline">スキル一覧</Link>
                <Link to="/portfolio" className="mx-2 text-white hover:underline">ポートフォリオ</Link>
                <button
                  onClick={handleLogout}
                  className="ml-4 bg-red-500 px-2 py-1 rounded hover:bg-red-600"
                >
                  ログアウト
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="mx-2 text-white hover:underline">ログイン</Link>
                <Link to="/signup" className="mx-2 text-white hover:underline">新規登録</Link>
              </>
            )}
          </nav>
        </header>

        <main className="p-4">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/skills"
              element={
                <ProtectedRoute>
                  <SkillForm onSkillAdded={handleSkillAdded} userId={userId} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/skills-list"
              element={
                <ProtectedRoute>
                  <SkillList userId={userId} skills={skills} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/portfolio"
              element={
                <ProtectedRoute>
                  <PortfolioPreview userId={userId}/>
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="/signup" element={<SignUp onSignUp={handleSignUp} />} /> {/* 新規登録ルート追加 */}
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
